<template>
  <div class="s-amoivaia-calculator-past">
    <Loader v-if="isLoading" display="absolute"></Loader>
    <Alert v-if="errorMsgs.length" type="danger" :messages="errorMsgs" />

    <div class="s-amoivaia-calculator-past__tag">
      <span>{{ dictionary.calculatorPastDataTagLabel }}</span>
    </div>
    <div class="s-amoivaia-calculator-past__header">
      <div class="s-amoivaia-calculator-past__title">
        {{ dictionary.calculatorPastDataTitle }}
      </div>
      <div
        class="s-amoivaia-calculator-past__subtitle"
        v-html="dictionary.calculatorPastDataSubtitle"></div>
    </div>
    <div class="s-amoivaia-calculator-past__body">
      <div class="s-amoivaia-calculator-past__body__input-prefix">
        {{ dictionary.calculatorPastDataInputPrefix }}
      </div>
      <div class="d-flex" style="gap: 24px; align-items: flex-end">
        <select
          v-model="years"
          name="years"
          class="s-amoivaia-calculator-past__body__input"
          @change="fetchData">
          <option
            v-for="(option, index) in yearsOptions"
            :key="index"
            :value="option.value"
            :selected="option.selected">
            {{ option.label }}
          </option>
        </select>
        <div class="s-amoivaia-calculator-past__body__input-suffix">
          {{ dictionary.calculatorPastDataInputSuffix }}
        </div>
      </div>
      <div class="s-amoivaia-calculator-past__body__results">
        <div
          v-for="card in results"
          :key="card.id"
          class="s-amoivaia-calculator-past__body__results__card d-none d-lg-block">
          <div class="s-amoivaia-calculator-past__body__results__card__top">
            <span
              class="s-amoivaia-calculator-past__body__results__card__top__title">
              {{ dictionary.calculatorPastDataResultsSavingsTitle }}
            </span>
            <div class="d-flex align-items-end">
              <span
                class="s-amoivaia-calculator-past__body__results__card__top__price">
                {{ card.savings }}
              </span>
              <span
                class="s-amoivaia-calculator-past__body__results__card__top__price-suffix">
                {{ dictionary.calculatorPastDataResultsSavingsSuffix }}
              </span>
            </div>
          </div>
          <div class="s-amoivaia-calculator-past__body__results__card__bottom">
            <div class="d-flex flex-column">
              <span
                class="s-amoivaia-calculator-past__body__results__card__bottom__title">
                {{ dictionary.calculatorPastDataResultsTitle }}
              </span>
              <span
                class="s-amoivaia-calculator-past__body__results__card__bottom__price">
                {{ card.totalAmount }}
              </span>
            </div>
            <div>
              <div class="e-percentage-bar">
                <div
                  class="e-percentage-bar__fill"
                  :style="{
                    width: getPercentage(card.totalAmountInt) + '%',
                  }"></div>
              </div>
            </div>
          </div>
        </div>

        <SlickCarousel
          ref="slick"
          :key="'key-' + slickKey"
          class="s-amoivaia-calculator-past__slick d-block d-lg-none"
          :options="slickOptions">
          <div
            v-for="card in results"
            :key="card.id"
            class="s-amoivaia-calculator-past__body__results__card item"
            style="width: auto">
            <div class="s-amoivaia-calculator-past__body__results__card__top">
              <span
                class="s-amoivaia-calculator-past__body__results__card__top__title">
                {{ dictionary.calculatorPastDataResultsSavingsTitle }}
              </span>
              <div class="d-flex align-items-end">
                <span
                  class="s-amoivaia-calculator-past__body__results__card__top__price">
                  {{ card.savings }}
                </span>
                <span
                  class="s-amoivaia-calculator-past__body__results__card__top__price-suffix">
                  {{ dictionary.calculatorPastDataResultsSavingsSuffix }}
                </span>
              </div>
            </div>
            <div
              class="s-amoivaia-calculator-past__body__results__card__bottom">
              <div class="d-flex flex-column">
                <span
                  class="s-amoivaia-calculator-past__body__results__card__bottom__title">
                  {{ dictionary.calculatorPastDataResultsTitle }}
                </span>
                <span
                  class="s-amoivaia-calculator-past__body__results__card__bottom__price">
                  {{ card.totalAmount }}
                </span>
              </div>
              <div>
                <div class="e-percentage-bar">
                  <div
                    class="e-percentage-bar__fill"
                    :style="{
                      width: getPercentage(card.totalAmountInt) + '%',
                    }"></div>
                </div>
              </div>
            </div>
          </div>
        </SlickCarousel>
      </div>
    </div>

    <div class="s-amoivaia-calculator__footer">
      <div ref="toggleBtn" class="toggleBtn" @click="toggleChange">
        <span>{{ dictionary.calculatorPastDataConditionsLabel }}</span>
        <i class="icon-chevron-down"></i>
      </div>
      <div
        ref="toggleContent"
        class="toggleContent"
        v-html="conditionsText"></div>
    </div>
  </div>
</template>
<script>
import * as lib from './../../lib/lib'
import axios from 'axios'
import Loader from '../components/common/Loader.vue'
import Alert from '../components/common/Alert.vue'
import SlickCarousel from './../components/common/SlickCarousel.vue'

export default {
  components: {
    Loader,
    Alert,
    SlickCarousel,
  },
  data() {
    return {
      // default
      isLoading: false,
      errorMsgs: [],

      slickKey: 0,
      slickOptions: {
        infinite: false,
        autoplay: false,
        arrows: false,
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        responsive: [
          {
            breakpoint: 992,
            settings: { slidesToShow: 2 },
          },
          {
            breakpoint: 768,
            settings: { slidesToShow: 1.1 },
          },
        ],
      },

      years: 0,
      yearsOptions: null,

      results: null,
      conditionsText: '',
    }
  },
  mounted() {
    const { yearsOptions, conditionsText } = lib.getData(
      'amoivaiaCalculatorPastData'
    )
    this.yearsOptions = yearsOptions
    this.conditionsText = conditionsText

    this.setPreselectedValues()
  },
  methods: {
    findBiggestNumber() {
      if (!this.results) return
      return Math.max(...this.results.map((i) => i.totalAmountInt))
    },

    getPercentage(number) {
      return Math.round((number / this.findBiggestNumber()) * 100)
    },
    setPreselectedValues() {
      this.years = this.yearsOptions.find((i) => i.selected).value

      this.fetchData()
    },

    toggleChange() {
      const toggleBtn = this.$refs.toggleBtn
      const toggleContent = this.$refs.toggleContent
      toggleContent.classList.toggle('show')
      toggleBtn.classList.toggle('active')
    },

    fetchData() {
      this.isLoading = true

      const postData = {
        years: this.years,
        reCaptchaPublicKey: this.configuration.reCaptchaPublicKey,
      }

      axios
        .post(this.configuration.dataHandler, postData)
        .then((response) => {
          const { hasError, errorMessages, data } = response.data
          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }

          const { results } = data
          this.results = results

          this.$nextTick(() => {
            this.handleSuccess()
            this.$refs.slick.reSlick()
          })
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },
  },
}
</script>
